// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import NonTrackedPinModalBody from './non-tracked-pin-modal-body';
import NonTrackedPinModalHeader from './non-tracked-pin-modal-header';
import Pin from '@deere/cps-it.warranty-model-factory/lib/pin';
import {WarrantyMediumModal} from '../../../../shared/components/modal/index';

const NonTrackedPinModal = props =>
    <section className='non-tracked-pin-modal'>
        <WarrantyMediumModal isOpen={props.isNonTrackedPinModalVisible}>
            <NonTrackedPinModalHeader onClose={props.onClose}/>
            <NonTrackedPinModalBody
                dealers={props.dealers}
                onCreate={props.onCreate}
                onDealerLocationChange={props.onDealerLocationChange}
                onFailedDateChange={props.onFailedDateChange}
                onInvoiceNumberChange={props.onInvoiceNumberChange}
                onInvoicedDateChange={props.onInvoicedDateChange}
                pin={props.pin}
            />
        </WarrantyMediumModal>
    </section>;

NonTrackedPinModal.displayName = 'NonTrackedPinModal';
NonTrackedPinModal.propTypes = {
    dealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    isNonTrackedPinModalVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCreate: PropTypes.func.isRequired,
    onDealerLocationChange: PropTypes.func.isRequired,
    onFailedDateChange: PropTypes.func.isRequired,
    onInvoiceNumberChange: PropTypes.func.isRequired,
    onInvoicedDateChange: PropTypes.func.isRequired,
    pin: PropTypes.instanceOf(Pin).isRequired
};

export default NonTrackedPinModal;



// WEBPACK FOOTER //
// ./src/claim/shared/components/non-tracked-pin-modal/index.js